<template>
  <div style="margin-top: 10px;font-size: 16px;">
    <div>
      <label class="label">车主姓名</label>
      <label v-if="work.ownerName" class="value">{{work.ownerName}}</label>
      <label v-else style="color: #646464;" class="value">无</label>
    </div>
    <div>
      <label class="label">车牌</label><label class="value">{{work.carNo}}</label>
    </div>
    <div>
      <label class="label">品牌/车型</label><label class="value">{{work.brandName}} / {{work.model}}</label>
    </div>
    <div>
      <label class="label">服务顾问</label><label class="value">{{work.consultantName}}</label>
    </div>
    <div>
      <label class="label">到厂时间</label><label class="value">{{work.enterTime}}</label>
    </div>
    <div>
      <label class="label">交车时间</label>
      <label class="value" @click="openDateTimePicker">{{work.estimateDeliveryTime}}</label>
      <van-popup v-model="showDateTimePicker" position="bottom" style=" height: 60%">
        <van-datetime-picker
          v-model="editEstimateDeliveryTime"
          type="datetime"
          title="选择交车时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="confirm"
          @cancel="cancel">
        </van-datetime-picker>
      </van-popup>
    </div>
    <div>
      <label class="label">是否加急</label><label class="value">{{work.urgent ? '是' : '否'}}</label>
    </div>
    <div>
      <label class="label">前工序</label>
      <label v-if="work.prevProcedureId" class="value">{{work.prevProcedureId | valueName('Procedure')}}</label>
      <label v-else style="color: #646464;" class="value">无</label>
    </div>
    <div>
      <label class="label">前施工人</label>
      <label v-if="work.prevTechnicianName" class="value">{{work.prevTechnicianName}}</label>
      <label v-else style="color: #646464;" class="value">无</label>
    </div>
    <div>
      <label class="label">当前工序</label><label class="value">
      {{work.procedureId | valueName('Procedure')}}</label>
    </div>
    <div>
      <label class="label">当前施工人</label>
      <label v-if="work.technicianId" class="value">{{work.technicianName}}</label>
      <label v-else-if="work.machineTechnicianName" class="value">{{work.machineTechnicianName}}</label>
      <label v-else style="color: #646464;" class="value">无</label>
    </div>
    <div>
      <label class="label">是否中断</label><label class="value">{{work.status === 'INTERRUPT' ? '是' : '否'}}</label>
    </div>
    <div v-if="work.status === 'INTERRUPT'">
      <label class="label">中断原因</label><label class="value">{{work.statusReason}}</label>
    </div>
    <div>
      <label class="label">备注</label>
      <label v-if="work.remarks" class="value">{{work.remarks}}</label>
      <label v-else style="color: #646464;" class="value">无</label>
    </div>
  </div>
</template>

<script>
  import { DatetimePicker, Popup } from 'vant'
  import authority from '@/utils/authority'

  export default {
    name: 'WxWorkDetailPanel',
    components: {
      [DatetimePicker.name]: DatetimePicker,
      [Popup.name]: Popup
    },
    props: {
      work: Object
    },
    data () {
      return {
        editEstimateDeliveryTime: null,
        showDateTimePicker: false
      }
    },
    methods: {
      openDateTimePicker () {
        if (this.pattern === authority.CONFIRM_WORK || this.pattern === authority.DISPATCH) {
          this.editEstimateDeliveryTime = new Date(this.work.estimateDeliveryTime)
          this.showDateTimePicker = true
        }
      },
      confirm () {
        this.work.estimateDeliveryTime = new Date(this.editEstimateDeliveryTime).format('yyyy-MM-dd hh:mm')
        this.showDateTimePicker = false
      },
      cancel () {
        this.showDateTimePicker = false
      }
    },
    computed: {
      minDate () {
        return new Date()
      },
      maxDate () {
        const date = new Date()
        date.setTime(date.getTime() + 180 * 24 * 60 * 60 * 1000)
        return date
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    font-size: 15px;
    display: inline-block;
    width: 120px;
    color: #646464;
    text-align: right;
    height: 34px;
    line-height: 34px;
  }

  .value {
    font-size: 16px;
    display: inline-block;
    color: black;
    height: 28px;
    line-height: 34px;
    margin-left: 34px;
  }
</style>
